export default __webpack_public_path__ + "static/media/iconly-bold-tick-square.5e2f2078.svg";